export default __webpack_public_path__ + "static/media/isopeptidique_link.05fc79b2.gif";